/** @param {import('./state').EditingSheet} sheet */
export const countEnabledColumns = sheet => {
  if (!sheet.enabled) return 0;
  let count = 0;
  for (const col of Object.values(sheet.columnMap)) {
    if (col.orphaned) continue;
    if (col.available === false) continue;
    if (col.mandatory || col.enabled) count++;
  }
  return count;
};
